/**
 * Shared pagination envelope returned by paginated list endpoints (ADR-0023).
 *
 * Mirror of `Paginated<T>` in `src/http/pagination.ts`. Cursor is opaque to
 * the client — pass it back as `?cursor=` to fetch the next page.
 */
export interface Paginated<T> {
  items: T[];
  nextCursor: string | null;
  hasMore: boolean;
  total?: number;
}

export function buildPaginatedUrl(
  path: string,
  cursor: string | null,
  limit?: number,
  extra?: Record<string, string | undefined>,
): string {
  const params = new URLSearchParams();
  if (limit !== undefined) params.set('limit', String(limit));
  if (cursor) params.set('cursor', cursor);
  if (extra) {
    for (const [k, v] of Object.entries(extra)) {
      if (v !== undefined && v !== '') params.set(k, v);
    }
  }
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}
